import axiosInstance from "../lib/axiosInstance";

const baseUrl = process.env.REACT_APP_API_URL;

const authModel = class {    
    async login(data) {
        return await axiosInstance.post(baseUrl+"/admin/login", data);
    }

}


export default new authModel();
